export interface SelectOption<T extends string = string> {
  value: T;
  label: string;
  disabled?: boolean;
}

/** `{ ROUND_90: 'Final ,90' }` → opções, na ordem em que o mapa de rótulos foi escrito. */
export function optionsFromLabels<T extends string>(labels: Record<T, string>): SelectOption<T>[] {
  return (Object.keys(labels) as T[]).map((value) => ({ value, label: labels[value] }));
}
